//  Requires script name to be defined on global interface
//  Call these functions in the onmounted of the component

/*
  Create and append the script to the document
*/
export const appendScriptToDocument = (url: string, callback?: void) => {
  const jsContainer = document.createElement('script');
  jsContainer.setAttribute('type', 'text/javascript');
  jsContainer.src = url;

  if (callback) jsContainer.addEventListener('load', callback);
  document.head.append(jsContainer);
};

/*
  Create and append the style to the document
*/
export const appendStyleToDocument = (url: string) => {
  const cssContainer = document.createElement('link');
  cssContainer.setAttribute('rel', 'stylesheet');
  cssContainer.setAttribute('type', 'text/css');
  cssContainer.setAttribute('href', url);
  document.head.append(cssContainer);
};
